import { render, staticRenderFns } from "./CancelContract.vue?vue&type=template&id=2dce8374&"
import script from "./CancelContract.vue?vue&type=script&lang=js&"
export * from "./CancelContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports